// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"29bf3cb970ab02b6","6831":"39d50311f895c057","8503":"c4386b3c55fde891","9683":"c638a3fbcc2cc6bc"}[chunkId] + ".js";
};